export type UserPreferences = {
  dismissCloseoutTrackerInfoDialog?: boolean;
};

export const emptyUserPreferences: UserPreferences = {};
